import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailContextWrapperComponent } from './detail-context-wrapper/detail-context-wrapper.component';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
  {
    path: 'welcome',
    loadComponent: () => import('./login/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    component: DetailContextWrapperComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'admin',
        loadComponent: () => import('./admin-panel/admin-panel.component').then(m => m.AdminPanelComponent),
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'users', pathMatch: 'full' },
          {
            path: 'users',
            loadComponent: () => import('./admin-panel/admin-users/admin-users.component').then(m => m.AdminUsersComponent),
          },
          {
            path: 'pillars',
            loadComponent: () => import('./admin-panel/admin-pillars/admin-pillars.component').then(m => m.AdminPillarsComponent),
          },
          {
            path: 'audit',
            loadComponent: () => import('./admin-panel/admin-audit/admin-audit.component').then(m => m.AdminAuditComponent),
          },
          {
            path: 'congresses',
            loadComponent: () => import('./admin-panel/admin-congresses/admin-congresses.component').then(m => m.AdminCongressesComponent),
          },
        ],
      },
      { path: '', redirectTo: '', pathMatch: 'full' },
      { path: '**', redirectTo: '', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
